import { BaseView } from 'Common/BaseView';

export class InformationBaseView extends BaseView {

    constructor() {
        super();
    }

    public GoBack() {
        window.history.back();
    }
}